<template>
  <div>
    <h1>Hello root</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
